import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { supabase } from "@/integrations/supabase/client";
import { Link } from "react-router-dom";

const LoginForm = () => {
  // Get the current domain for proper redirects
  const domain = window.location.origin;

  return (
    <>
      <div className="text-center">
        <h2 className="mt-6 text-3xl font-bold text-gray-900">Welcome back</h2>
        <p className="mt-2 text-sm text-gray-600">
          Sign in to access your dashboard
        </p>
      </div>
      <div className="w-full">
        <Auth
          supabaseClient={supabase}
          appearance={{
            theme: ThemeSupa,
            variables: {
              default: {
                colors: {
                  brand: '#2563eb',
                  brandAccent: '#1d4ed8',
                }
              }
            },
            className: {
              container: 'w-full',
              button: 'w-full',
              input: 'rounded-md',
            }
          }}
          providers={[]}
          redirectTo={`${domain}/dashboard`}
          theme="light"
          view="sign_in"
          showLinks={true}
          localization={{
            variables: {
              sign_up: {
                link_text: ''
              }
            }
          }}
        />
        <div className="mt-4 text-center">
          <Link 
            to="/request-password-reset" 
            className="text-sm text-blue-600 hover:text-blue-800 transition-colors"
          >
            Forgot your password?
          </Link>
        </div>
      </div>
    </>
  );
};

export default LoginForm;